import { AboutYouQuestionType, KNOCKOUT_MESSAGE } from '@acorn/util';

export const KNOCKOUT_MESSAGES_QUESTION_TYPE_MAP: Map<string, string> = new Map(
  [[AboutYouQuestionType.AYCitizenshipStatus, KNOCKOUT_MESSAGE.CITIZENSHIP]]
);

export const KNOCKOUT_MESSAGES_QUESTION_TYPE_MAP_FOR_DUAL_RESPONDENTS: Map<string, string> = new Map(
  [[AboutYouQuestionType.AYCitizenshipStatus, KNOCKOUT_MESSAGE.CITIZENSHIP_FOR_DUAL_RESPONDENTS]]
);
